import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { v1 as uuid } from 'uuid';
import BaseModal from '../../../_shared/components/BaseModal';
import { StyledTitle } from '../../../_shared/components/ConfirmModal/Styles';
import {
  ModalDescription,
  StyledCancelButton,
  StyledDeclineFooter,
  StyledSendToClosingButton,
  StyledSendToLostButton
} from './Styles';
import SendToClosingContainer from '../../ModalButton/NegotiationButton/SendToClosingContainer';
import SendToLostContainer from '../../ModalButton/NegotiationButton/SendToLostContainer';

const SellerDeclineModal = ({ trade, topBid, isOpen, onCancel, isOmp }) => {
  const [isSendToLostModalOpen, setIsSendToLostModalOpen] = useState(false);
  const messages = [
    <FormattedMessage id="modal.negotiation.decline.seller.description.msg1" />,
    <FormattedMessage id="modal.negotiation.decline.seller.description.msg2" />
  ];

  const onCloseSendToLostModal = () => {
    setIsSendToLostModalOpen(false);
  };

  const onOpenSendToLostModal = () => {
    setIsSendToLostModalOpen(true);
  };

  return (
    <BaseModal
      testId="sellerDeclineFirstOffer-confirm-modal"
      isOpen={isOpen}
      width={500}
      padding="36px"
      hasParentSelector={isOmp}
    >
      <StyledTitle>
        <FormattedMessage id="modal.negotiation.decline.seller.title" />
      </StyledTitle>
      {messages.map((message, i) => {
        return (
          <ModalDescription
            key={uuid()}
            data-testid={`sellerDeclineModal-${i}`}
          >
            {message}
          </ModalDescription>
        );
      })}

      <StyledDeclineFooter>
        <div>
          <StyledCancelButton
            onClick={() => {
              onCancel(!isOpen);
            }}
          >
            <FormattedMessage id="modal.cancel" />
          </StyledCancelButton>
        </div>

        <div>
          <SendToLostContainer
            trade={trade}
            isOpen={isSendToLostModalOpen}
            onClose={onCloseSendToLostModal}
            Button={() => (
              <StyledSendToLostButton onClick={onOpenSendToLostModal}>
                <FormattedMessage id="modal.negotiation.decline.seller.sendToLost" />
              </StyledSendToLostButton>
            )}
          />

          <SendToClosingContainer
            trade={trade}
            topBid={topBid}
            Button={({ onClick }) => (
              <StyledSendToClosingButton onClick={onClick}>
                <FormattedMessage id="modal.negotiation.decline.seller.sendToClosing" />
              </StyledSendToClosingButton>
            )}
          />
        </div>
      </StyledDeclineFooter>
    </BaseModal>
  );
};

export default SellerDeclineModal;
